<!-- ni-autocomplete.component.html -->
<div #containerRef class="ni-autocomplete-container outline-none pointer-events-auto  " [class.w-full]="fluid"
  [class.pointer-events-none]="disabled" [style]="style" [class]="styleClass"
  [attr.aria-label]="getAriaLabel()" [attr.aria-labelledby]="getAriaLabelledBy()"
  [attr.aria-describedby]="getAriaDescribedBy()" [attr.aria-controls]="getAriaControls()"
  [attr.aria-expanded]="getAriaExpanded()" [attr.aria-autocomplete]="getAriaAutoComplete()"
  [attr.aria-haspopup]="getAriaHasPopup()" [attr.aria-activedescendant]="getAriaActiveDescendant()"
  (focus)="focusContainer()" (blur)="onInputBlur()" [tooltip]="tooltip" [position]="tooltipPosition"
  [alwaysVisible]="tooltipEvent === 'always'" [theme]="tooltipTheme">
  <!-- Label -->
  <label *ngIf="label" class="ni-autocomplete-label leading-[29px]" [for]="inputId">
    {{ label }}
    <span *ngIf="required" class="ni-autocomplete-required">*</span>
  </label>

  <!-- Main Input Container -->
  <div class="ni-input-container pointer-events-auto cursor-pointer relative" 
    [ngClass]="{'bg-gray-200': disabled}"
    (pointerdown)="!disabled && !isLoading && handleContainerClick($event)">
    <!-- Loading Skeleton -->
    @if (isLoading) {
    <div @skeletonFadeIn class="absolute inset-0 flex items-center px-4 pointer-events-none z-20 bg-transparent rounded-lg border border-gray-600 shadow-sm min-h-[3.625rem]"
      [ngClass]="{
        'border-danger-500': hasError,
        'border-gray-600': !hasError
      }">
      <div class="w-full h-6 bg-gray-200 rounded skeleton-shimmer relative"></div>
    </div>
    }


    <!-- Multiple Selection Container -->
    <div *ngIf="multiple" [class]="getContainerClasses()">
      <!-- Chips Container -->
      <div *ngIf="selectedOptions.length > 0" #chipsContainerRef
        [class]="'ni-chips-container' + (hasError ? ' error' : '')" (click)="handleChipsContainerClick($event)" (keydown.enter)="handleChipsContainerClick($event)">
        <div *ngFor="let option of getVisibleChips(); trackBy: trackByValue" data-chip-item class="ni-chip"
          [ngClass]="{'font-bold': disabled}">
          <span class="truncate min-w-0 flex-1">{{ getOptionLabel(option) }}</span>
          <button *ngIf="!disabled" type="button" tabindex="-1" class="ni-chip-remove flex-shrink-0"
            (click)="removeItem(option); $event.stopPropagation();"
            [attr.aria-label]="'Remove ' + getOptionLabel(option)">
            <svg class="h-2 w-2 text-red-500" stroke="currentColor" fill="none" viewBox="0 0 8 8">
              <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
            </svg>
          </button>
        </div>
        <!-- Overflow Indicator -->
        <span *ngIf="getHiddenChipsCount() > 0" class="ni-overflow-indicator">...</span>
        <div *ngIf="getHiddenChipsCount() > 0" class="ni-chip-count" (click)="handleCountChipClick($event)" (keydown.enter)="handleCountChipClick($event)">
          <span>+{{ getHiddenChipsCount() }}</span>
        </div>
      </div>

      <!-- Placeholder -->
      <div *ngIf="selectedOptions.length === 0"
        [class]="'ni-chips-placeholder text-gray-500 font-archivo pointer-events-none' + (hasError ? ' error' : '')"
        [ngClass]="{'font-bold': disabled}"
        (click)="handlePlaceholderClick($event)" (keydown.enter)="handlePlaceholderClick($event)">
        {{ placeholder || 'Choose a tag...' }}
      </div>
    </div>
    <!-- 🔒 Hidden Measurement Container (for chip width calculation only) -->
    <div #chipMeasureRef class="absolute opacity-0 pointer-events-none"
      style="position: absolute; visibility: hidden; height: 0; overflow: hidden;">
      <div *ngFor="let option of selectedOptions" class="ni-chip" data-measure-chip>
        <span class="truncate min-w-0 flex-1">{{ getOptionLabel(option) }}</span>
        <button type="button" class="ni-chip-remove flex-shrink-0">
        </button>
      </div>
    </div>

    <!-- Single Selection Input -->
    <div *ngIf="!multiple" class="ni-single-container relative pointer-events-none" 
      [style.opacity]="isLoading ? '0' : '1'" 
      [style.transition]="'opacity 200ms ease-out'"
      [style.background-color]="isLoading ? 'transparent' : null">
      <!-- Leading Icon -->
      <div *ngIf="!disabled"
        class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none z-10">
        <NiFormIcon *ngIf="leadingIcon" [icon]="leadingIcon" iconClass="!w-[18px] !h-[18px]">
        </NiFormIcon>

      </div>
      <input #inputRef [type]="inputType" [id]="inputId" [placeholder]="placeholder" [value]="getDisplayValue()"
        [disabled]="disabled" [readonly]="readonly && !typeahead" [tabindex]="tabindex" [style]="inputStyle"
        [class.error]="hasError" [attr.maxlength]="maxLength" [attr.pattern]="inputPattern"
        [class]="'ni-input-field w-full pointer-events-none font-archivo text-[16px] lg:text-[20px] md:text-[20px] sm:text-[20px] xs:text-[20px] border-0 shadow-none outline-none flex-1 placeholder:text-[16px] placeholder:lg:text-[20px] placeholder:md:text-[20px] placeholder:sm:text-[20px] placeholder:xs:text-[20px] placeholder:text-gray-500 placeholder:font-archivo relative z-0 ' + (leadingIcon && !disabled ? '!pl-[40px] ' : '') + (inputStyleClass || '')"
        [ngClass]="{'bg-transparent': !disabled, 'bg-gray-200 font-bold': disabled}"
        niTooltip [tooltip]="tooltip" [position]="tooltipPosition" [alwaysVisible]="tooltipEvent === 'always'"
        (click)="onInputClick($event)" (mousedown)="onInputMouseDown($event)" (input)="onInputChange($event)"
        (keydown)="handleKeyDown($event)" (focus)="onInputFocus()" (blur)="onInputBlur()" 
        [attr.autocomplete]="getAutocompleteValue()" [attr.data-form-type]="'other'" [attr.data-lpignore]="'true'" [attr.data-1p-ignore]="'true'" [name]="getAutocompleteSafeName()">
    </div>

    <!-- Buttons Container -->
    <div class="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center gap-1">
      <!-- Clear Button -->
      <button
        *ngIf="!disabled && showClearButton && !isLoading && !loading && ((!multiple && selected) || (multiple && selectedOptions.length > 0))"
        type="button" tabindex="-1" class="ni-clear-button !static !transform-none pointer-events-auto"
        [attr.aria-label]="'Clear selection'" 
        (click)="clearSelection($event)"
        (focus)="preventFocus($event)"
        (mousedown)="$event.preventDefault()"
        (keydown.tab)="$event.preventDefault()">
      </button>

      <!-- Dropdown Button -->
      <button *ngIf="showDropdownIcon && !disabled" type="button" tabindex="-1"
        class="ni-dropdown-button !static !transform-none pointer-events-auto" [attr.aria-label]="'Toggle dropdown'"
        [attr.aria-expanded]="getAriaExpanded()" 
        (click)="handleDropdownClick($event)"
        (focus)="preventFocus($event)"
        (mousedown)="$event.preventDefault()"
        (keydown.tab)="$event.preventDefault()">
        <NiFormIcon [icon]="dropdownIcon" class="ni-dropdown-button-icon" [class.rotate-180]="showOptions"></NiFormIcon>
      </button>
    </div>

    <!-- Loading Indicator -->
    <div *ngIf="loading" class="ni-loading-container">
      <div class="ni-loading-spinner"></div>
    </div>
  </div>

  <!-- Error Message -->
  <div class="flex items-end justify-between min-h-[25px]">
    <span *ngIf="hasError" class="flex items-end justify-between text-danger-500 text-[14px] font-archivo">{{errorMessage}}</span>
  </div>



  <!-- Options Dropdown -->
  <div #optionsRef *ngIf="showOptions" [class]="getOptionsDropdownClasses()" @dropDownMenu style="z-index: 1000;">
    <!-- Action Section (Top) -->
    <ng-container *ngIf="showActionSection && actionSectionPosition === 'top' && actionButtons.length > 0">
      <ng-container *ngTemplateOutlet="actionSectionTemplate; context: { position: 'top' }"></ng-container>
    </ng-container>

    <!-- Search Input -->
    <div *ngIf="multiple" class="ni-dropdown-search-container ">
      <input #dropdownSearchRef [type]="inputType" [(ngModel)]="query" (input)="filterOptions(); detectChanges()"
        (mousedown)="onDropdownSearchInputMouseDown()" (focus)="onDropdownSearchInputFocus()"
        [attr.maxlength]="maxLength" [attr.pattern]="inputPattern" niTooltip [tooltip]="tooltip"
        [position]="tooltipPosition" [theme]="tooltipTheme" [alwaysVisible]="tooltipEvent === 'always'"
        placeholder="Search..." class="ni-dropdown-search-input" 
        [attr.autocomplete]="getAutocompleteValue()" [attr.data-form-type]="'other'" [attr.data-lpignore]="'true'" [attr.data-1p-ignore]="'true'" [name]="getAutocompleteSafeName()" />
    </div>

    <!-- Options List -->
    <div
  *ngIf="
      !loading &&
      (
        filteredOptions.length > 0 ||
        (group && filteredGroups.length > 0) ||
        (isGoogleMap && query && query.length > 0)
      )"
       class="options-list-container" (scroll)="onOptionsPanelScroll($event)"
      (mousedown)="onOptionsContainerMouseDown($event)">

      <ng-container *ngIf="!loading">
        <!-- Grouped Options -->
        <div *ngIf="group && filteredGroups.length > 0">
          <div *ngFor="let group of filteredGroups; trackBy: trackByValue">
            <div class="ni-group-header">{{ group.label }}</div>
            <ng-container *ngFor="let option of group.items; trackBy: trackByValue; let index = index">
              <div class="menu-item">
                <NiFormOption [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                  [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                  [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                  (favoriteToggle)="onFavoriteToggle($event)"
                  (imageError)="onImageError($event.event, $event.option, $event.type)">
                </NiFormOption>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- Regular Options -->
        <div *ngIf="!group && filteredOptions.length > 0">
          <!-- When favorites are enabled, show favorites and non-favorites separately -->
          <ng-container *ngIf="showFavoriteToggle">
            <!-- Favorites Section -->
            <div *ngIf="favoriteFilteredOptions.length > 0" class="ni-favorites-section">
              <div class="ni-favorites-header">
                <span class="ni-favorites-label">FAVORITES</span>
              </div>
            </div>

            <ng-container *ngFor="let option of favoriteFilteredOptions; trackBy: trackByValue; let index = index">
              <div class="menu-item">
                <NiFormOption [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                  [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                  [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                  (favoriteToggle)="onFavoriteToggle($event)"
                  (imageError)="onImageError($event.event, $event.option, $event.type)">
                </NiFormOption>
              </div>
            </ng-container>

            <!-- Separator between favorites and regular options -->
            <div *ngIf="favoriteFilteredOptions.length > 0 && nonFavoriteFilteredOptions.length > 0"
              class="ni-separator"></div>

            <!-- Non-Favorite Section -->
            <ng-container *ngFor="let option of nonFavoriteFilteredOptions; trackBy: trackByValue; let index = index">
              <div class="menu-item">
                <NiFormOption [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                  [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                  [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                  (favoriteToggle)="onFavoriteToggle($event)"
                  (imageError)="onImageError($event.event, $event.option, $event.type)">
                </NiFormOption>
              </div>
            </ng-container>
          </ng-container>

          <!-- When favorites are disabled, show all options in one list -->
          <ng-container *ngIf="!showFavoriteToggle">
            <ng-container *ngFor="let option of filteredOptions; trackBy: trackByValue; let index = index">
              <div class="menu-item">
                <NiFormOption [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                  [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                  [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                  (favoriteToggle)="onFavoriteToggle($event)"
                  (imageError)="onImageError($event.event, $event.option, $event.type)">
                </NiFormOption>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <!-- Loading/Empty Messages -->
    <div *ngIf="loading" class="ni-loading-message menu-item">...</div>
    <div *ngIf="
      !loading &&
      filteredOptions.length === 0 &&
      !group && 
      (
        (!isGoogleMap) || 
        (isGoogleMap && query && query.length > 0)
      )
  " class="ni-empty-message menu-item">No results found</div>

    <!-- Action Section (Bottom) -->
    <ng-container *ngIf="showActionSection && actionSectionPosition === 'bottom' && actionButtons.length > 0">
      <ng-container *ngTemplateOutlet="actionSectionTemplate; context: { position: 'bottom' }"></ng-container>
    </ng-container>
  </div>

  <!-- Action Section Template (shared) -->
  <ng-template #actionSectionTemplate let-position="position">
    <div [class]="'ni-action-section ni-action-section-' + position + (position === 'top' ? ' !top-[85%]' : '')">
      <div class="ni-action-buttons" [ngClass]="{
        'ni-action-buttons-left': actionSectionAlignment === 'left',
        'ni-action-buttons-center': actionSectionAlignment === 'center',
        'ni-action-buttons-right': actionSectionAlignment === 'right'
      }">
        <button *ngFor="let button of actionButtons" type="button" class="ni-action-button"
          [class.ni-action-button-primary]="button.variant === 'primary'"
          [class.ni-action-button-secondary]="button.variant === 'secondary'"
          [class.ni-action-button-danger]="button.variant === 'danger'"
          [class.ni-action-button-success]="button.variant === 'success'"
          [class.ni-action-button-disabled]="button.disabled" [disabled]="button.disabled"
          (click)="onActionButtonClick(button.action, $event)">
          <div class="flex gap-2 items-center  justify-center">
            <NiFormIcon *ngIf="button.icon" [icon]="button.icon" class="ni-action-button-icon"></NiFormIcon>
            <span class="ni-action-button-label">{{ button.label }}</span>
          </div>
        </button>
      </div>
    </div>
  </ng-template>
</div>